export interface AuthConfig {
  tenantId: string;
  clientId: string;
  apiScope: string;
}

export const ENV_KEYS = {
  tenantId: "VITE_ENTRA_TENANT_ID",
  clientId: "VITE_ENTRA_WEB_CLIENT_ID",
  apiScope: "VITE_ENTRA_API_SCOPE",
} as const;

export type EnvKey = (typeof ENV_KEYS)[keyof typeof ENV_KEYS];

// Treat the .env.example placeholders (all-zero GUIDs, "<...>") as missing.
const PLACEHOLDER = /^(0{8}-0{4}-0{4}-0{4}-0{12}|.*<.*>.*)$/;

function read(value: string | undefined): string | undefined {
  const v = value?.trim();
  if (!v || PLACEHOLDER.test(v)) return undefined;
  return v;
}

export type AuthConfigResult = { ok: true; config: AuthConfig } | { ok: false; missing: EnvKey[] };

export function getAuthConfig(): AuthConfigResult {
  const tenantId = read(import.meta.env.VITE_ENTRA_TENANT_ID);
  const clientId = read(import.meta.env.VITE_ENTRA_WEB_CLIENT_ID);
  const apiScope = read(import.meta.env.VITE_ENTRA_API_SCOPE);
  if (tenantId && clientId && apiScope) return { ok: true, config: { tenantId, clientId, apiScope } };
  const missing: EnvKey[] = [];
  if (!tenantId) missing.push(ENV_KEYS.tenantId);
  if (!clientId) missing.push(ENV_KEYS.clientId);
  if (!apiScope) missing.push(ENV_KEYS.apiScope);
  return { ok: false, missing };
}

export const API_BASE_URL = (import.meta.env.VITE_API_BASE_URL?.trim() || "/api").replace(/\/$/, "");
